<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="光模块云编写器" :bannerList="bannerList"></swiper>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/opticalModule/dwdm.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/opticalModule/dwdm.png">
              <img src="@/assets/img/lg/opticalModule/dwdm.png"  class="image-width-100"/>
            </picture>
          </div>
        </div>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div v-for = "item in characteristicList" :key="item.title" class="col-lg-4 col-md-6 col-12 mb-3">
            <div class="shadow-box text-line-height-2">
              <img :src="item.src" class="image-width-100 transform-img" />
              <span class="blue-point font-weight-500 color-dark-grey">{{ item.title }}</span><br />
              <span class="color-desc">{{ item.titleDetail }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 客户背景 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="客户背景"></main-title>
        <desc-list :dataList="customerList"></desc-list>
      </div>
    </section>

    <!-- 产品亮点 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="产品亮点"></main-title>
        <desc-list :dataList="lightSpotList"></desc-list>
        <p class="color-desc title-sub">Box作为数据中心移动工具，既解决了光网络工程师面临的实时问题，
          而且可以不断升级收发器固件（包括部件号，序列号等），可以与升级后的交换机兼容。</p>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div v-for="item in dataList" :key="item.title" class="col-lg-4 col-md-6 col-12 mb-3 text-align-center">
            <span class="color-dark-grey font-weight-500"> {{ item.title }}</span><br />
            <span class="color-desc"> {{ item.titleDetail }}</span>
          </div>
          <img src="@/assets/img/common/opticalModule/oper-img.png"  class="image-width-100 pt-4 pb-4"/>
          <div class="text-align-center pt-4 pb-4">
            <span class="color-dark-grey font-weight-bold title-main">Box Smart Cloud Platform</span><br />
            <span class="color-desc title-sub">Easy to upgrade the firmware of transceivers and solve your configuration problems through
              this efficient and intelligent cloud system.
            </span>
          </div>
          <img src="@/assets/img/common/opticalModule/box-smart.png"  class="image-width-100 pt-4 pb-5"/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'OpticalModule',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/opticalModule/banner1.png") },
        { src: require("@/assets/img/common/caseList/opticalModule/banner2.png") },
        { src: require("@/assets/img/common/caseList/opticalModule/banner3.png") },
      ],
      characteristicList: [
        {
          src: require("@/assets/img/common/opticalModule/one.png"),
          title: 'Windows and Mac OS Systems Supported',
          titleDetail:'The cloud platform now supports two common operating systems,Windows (10 or newer) and Mac OS (10.13 or newer), providing users with wide operating options.'
        },
        {
          src: require("@/assets/img/common/opticalModule/two.png"),
          title: 'Transceiver Diagnostics and Troubleshooting',
          titleDetail:'No need more additonal devices, FS box can monitor the voltage, temperature, bias-current values, TX and RX power of the inserted transceiver in the reliable cloud platform.'
        },
        {
          src: require("@/assets/img/common/opticalModule/three.png"),
          title: 'Diagnosing Configuration to Solve After-sales',
          titleDetail:'The cloud platform can diagnose the information of the FS transceiver that works well to match the configuration file of FS  and reconfigure problematic transceiver to solve the after-sales problem.'
        }
      ],
      // 客户背景
      customerList: [
        {
          title: "先进的环境：",
          titleDetail:
            "为确保产品的质量、可靠性和互通性，我们建立了全面的测试环境，在实验室客官科学地运行应用程序，以检测产品“端到端”性能。",
        },
        {
          title: "以客户为中心：",
          titleDetail:
            "客户认为双赢是建立长期合作的基石，我们重视客户的满意度，提供个性化解决方案，重视每一个客户的建议和反馈。",
        },
        {
          title: "可持续发展：",
          titleDetail:
            "客户深知可持续发展才能使我们在未来走的更远。以质量和科学发展观为指导，贯彻落实可持续发展经营理念，高度重视经济、环境和社会各个方面。",
        }
      ],
      // 产品亮点
      lightSpotList: [
        {
          title: "用于客户收发器和DAC / AOC电缆的收发器工具套件",
          titleDetail: "",
        }
      ],
      dataList: [
        {
          title: "Massive Vendors",
          titleDetail: "200+Vendors Supported",
        },
        {
          title: "Multiple Ports",
          titleDetail: "SFP/SFP28/XFP/QSFP+/QSFP28",
        },
        {
          title: "Operating Systems",
          titleDetail: "Windows and Mac OS Supported",
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>